import { render, staticRenderFns } from "./quanbao.vue?vue&type=template&id=872ec36a&scoped=true&"
import script from "./quanbao.vue?vue&type=script&lang=js&"
export * from "./quanbao.vue?vue&type=script&lang=js&"
import style0 from "./quanbao.vue?vue&type=style&index=0&id=872ec36a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872ec36a",
  null
  
)

export default component.exports